import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

/**
 * Adds the bearer token to API requests. Failures are not handled here: apiErrorInterceptor turns
 * them into ApiError and answers a 401 by sending the user to sign in again.
 */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const authService = inject(AuthService);

    // Only add token for our API requests
    const isApiRequest = request.url.startsWith(environment.apiUrl);

    // Skip adding token for non-API requests
    if (!isApiRequest) {
        return next(request);
    }

    // For API requests, check if user is logged in and get token
    if (!authService.isLoggedIn()) {
        // User not logged in, proceeding without token
        return next(request);
    }

    // User is logged in, get the access token
    return from(authService.getAccessToken()).pipe(
        switchMap(token => {
            if (token) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    },
                    withCredentials: true
                });
            }
            return next(request);
        })
    );
};
